import { stringify } from "qs";

const appendSearch = (params: Record<string, string>) => {
  return stringify(params, { addQueryPrefix: true });
};

export function linkToWardPatientList(search: { wardId?: string } = {}) {
  return `/ward-patient-list${appendSearch(search)}`;
}
